import Vue from 'vue';
import DatetimePicker from 'vuetify-datetime-picker';

Vue.use(DatetimePicker);
